import { ReactComponent as CompleteIcon } from 'assets/svg/complete.svg'
import {
  StyledCompleteIcon,
  StyledCompleteInfo,
  StyledTransferComplete,
} from 'pages/Transfer/states/TransferComplete/TransferComplete.styled'
import { page } from 'translations'

export const TransferComplete = () => {
  return (
    <StyledTransferComplete>
      <StyledCompleteIcon>
        <CompleteIcon />
      </StyledCompleteIcon>
      <StyledCompleteInfo>{page.transfer.transferCompleted}</StyledCompleteInfo>
    </StyledTransferComplete>
  )
}
